import { render, staticRenderFns } from "./TopSupplier.vue?vue&type=template&id=1ab9e7d4&scoped=true&"
import script from "./TopSupplier.vue?vue&type=script&lang=js&"
export * from "./TopSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab9e7d4",
  null
  
)

export default component.exports